module.exports = __webpack_public_path__ + "static/Solution_Remote-a46d91ae823fd0e495261bc3da52e4a6.png";